export default "__VITE_ASSET__BsmxmHsc__"